// Drawer Functionality
document.addEventListener("DOMContentLoaded", function () {
  const trigger = document.querySelector(".drawer-trigger");
  const overlay = document.querySelector(".drawer-overlay");
  const drawerContent = document.querySelector(".drawer-content");
  const closeBtn = document.querySelector(".drawer-close");

  if (trigger && overlay && drawerContent) {
    trigger.addEventListener("click", function () {
      overlay.classList.add("active");
      drawerContent.classList.add("active");
    });

    overlay.addEventListener("click", function (event) {
      if (!event.target.closest(".drawer-content")) {
        closeDrawer();
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener("click", closeDrawer);
    }

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeDrawer();
      }
    });

    function closeDrawer() {
      overlay.classList.remove("active");
      drawerContent.classList.remove("active");
    }
  }
});

// Add addons to drawer content
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const upsellElement = document.querySelector(
      ".lb-upsell-ppa-card-cont-list-lt"
    );
    const drawerTrigger = document.querySelector(".drawer-trigger");

    if (upsellElement) {
      drawerTrigger.style.display = "flex";
    } else {
      drawerTrigger.style.display = "none";
    }
  }, 3000); // 3-second delay
});
